import { render } from "./IE_productionMonitoring.vue?vue&type=template&id=4b4f1b5d&scoped=true"
import script from "./IE_productionMonitoring.vue?vue&type=script&lang=js"
export * from "./IE_productionMonitoring.vue?vue&type=script&lang=js"

import "./IE_productionMonitoring.vue?vue&type=style&index=0&id=4b4f1b5d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4f1b5d"]])

export default __exports__